let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h7BTr")).then(() => parcelRequire('gBcDc'));